import { useQuery } from "@tanstack/react-query";
import appAxios from "services/axios";

export type OnboardingStepKey = "instagram" | "chatbot" | "test" | "ai" | "team";

export interface OnboardingState {
  steps: Array<{ key: OnboardingStepKey; done: boolean }>;
  // Подключённый (или ожидающий входа) Instagram-канал
  instagram: {
    channelConnectionID: number;
    username: string | null;
    connected: boolean;
    agentID: number | null;
  } | null;
  // Последний чат-бот в Instagram — для окна «Как протестировать чат-бота?»
  chatbot: {
    automationID: number;
    name: string;
    keywords: string[];
    direct: boolean;
    comment: boolean;
  } | null;
  agentID: number | null;
  sandboxChannelID: number | null;
}

// «Быстрый старт»: бэкенд считает выполненные шаги по данным организации
export const useGetOnboarding = (orgID: string | null) => {
  return useQuery({
    queryKey: ["onboarding", orgID],
    queryFn: async () => {
      const { data } = await appAxios.get<OnboardingState>(`/admin/orgs/${orgID}/onboarding`);
      return data;
    },
    enabled: !!orgID,
    // Шаги выполняются на других страницах — обновляем при возврате на дашборд
    refetchOnMount: "always",
  });
};
